export default {
  name: 'alert-checklist',
  components: {},
  props: ['checklist'],
  data () {
    return {
      showDismissibleAlert: true
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    color (status) {
      if (status) {
        switch (parseInt(status.code)) {
          case 0:
            return 'warning'
          case 1:
            return 'success'
          case 2:
            return 'danger'
          case 3:
            return 'primary'
          case 4:
            return 'info'
          case 5:
            return 'danger'
          default:
            return 'warning'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/alert-checklist/alert-checklist.js